import { Box, Button, Checkbox, Chip, Divider, Drawer, Fab, IconButton, Radio, FormControlLabel, FormControl, RadioGroup, TextField, Typography, Autocomplete, Tabs, Tab } from "@mui/material";
import React, { useEffect, useMemo, useState, useRef } from "react";
import { Stack } from "@mui/material";
import { useMCContext } from "./contexts/useMCStates";
import { useAuth } from "react-oidc-context";
import { StyledIconButton } from "./Components/StyledIconButton";
import { ArrowBack, HowToReg, InfoOutlined, Leaderboard, Login, Lock, Menu as MenuIcon, TaskAlt } from "@mui/icons-material";
import { StyledTextboxInput } from "./Components/StyledTextboxInput";
import { StyledAutocompleteInput } from "./Components/StyledAutocompleteInput";

import CreateApi from "./Settings/appSettings";
import { formatDateForDisplay, registrationCloseExclusive } from "@moment-golf/shared";
import { createCookie, getCookie } from "./contexts/CookieContext";
import { getRegistrationFieldOptions } from "../utils/registrationFieldUtils";
import { EarlyRegPriceDisplay } from "./Components/EarlyRegPriceDisplay";
import { FieldInfoButton } from "./Components/FieldInfoButton";
import {
    applyEarlyRegDiscount,
    formatDisplayPrice,
    getEarlyRegDiscountAmount,
    getFlightPriceRange,
    getPriceDisplaySuffix,
    getPriceForRegistration,
    getRegistrationTotalPrice,
    isEarlyRegistrationActive,
    scalePriceForDisplay,
    scalePriceRangeForDisplay,
    shouldShowResolvedRegistrationPrice,
} from "../utils/eventPricingUtils";
import { UserRegistered } from "./Components/UserRegistered";
import { MCHeader } from "./Components/MCHeader";
import { PriceDisplayModeToggle } from "./Components/PriceDisplayModeToggle";
import MenuSpanHeader from "./Components/MenuSpanHeader";
import PullToRefresh from "./services/PullToRefresh";
import { TipTapEditor } from "../Components/Components/TipTapEditor";
import { useNavigate, useLocation } from "react-router-dom";

const QUILTED_FLAG_LOGO = `${process.env.PUBLIC_URL || ''}/Quilted Flag - Bold Zoom Tilt.png`;

export const EventPage = () => {
    const { 
        appTheme, 
        viewEvent, 
        setViewEvent, 
        eventData, 
        cartItems, 
        setCartItems, 
        imageCache, 
        userRegistrations, 
        setUserRegistrations, 
        factor, 
        windowSize,
        priceDisplayMode,
    } = useMCContext();

    const auth = useAuth();
    const api = CreateApi();
    const navigate = useNavigate();
    const location = useLocation();

    const [isLoading, setIsLoading] = useState(true);
    /* const [emailError, setEmailError] = useState(false); */
    const [eventId, setEventId] = useState<string>('');
    const [uniqueRelatedPlayers, setUniqueRelatedPlayers] = useState<any[]>([]);
    const [regValidated, setRegValidated] = useState(false);
    const [registrationType, setRegistrationType] = useState<string>('individual');
    const [rivalryTeam, setRivalryTeam] = useState<string>('');
    const [registrationFields, setRegistrationFields] = useState<any[]>(viewEvent?.registrationForm || []);
    const [registrationForm, setRegistrationForm] = useState<any[]>(() => {
        if (!viewEvent?.registrationForm) return [];
        const playerFields = viewEvent.registrationForm.filter((field: any) => !field.regLevelData);
        return Array(viewEvent.regQty).fill(null).map(() =>
            playerFields.reduce((acc: any, field: any) => {
                acc[field.name] = field.field === 'checkbox' ? false : field.field === 'select' ? null : '';
                return acc;
            }, {})
        );
    });

    const [registrationLevelData, setRegistrationLevelData] = useState<Record<string, any>>({});
    const [registrationClosed, setRegistrationClosed] = useState(false);
    const [registrationNotYetOpen, setRegistrationNotYetOpen] = useState(false);
    const [fieldFull, setFieldFull] = useState(false);
    const [leaderboardLocked, setLeaderboardLocked] = useState(false);

    const [maxHeight, setMaxHeight] = useState(window.innerHeight);
    const [startY, setStartY] = useState(0);
    const [pullDistance, setPullDistance] = useState(0);
    const stackRef = useRef<HTMLDivElement>(null);
    const threshold = 100;
    const [eventPageTab, setEventPageTab] = useState(0);
    const [drawerOpen, setDrawerOpen] = useState(false);

    const isMobileLayout = windowSize.isMobile || windowSize.verticalPC !== 'none' || ['small'].includes(windowSize.horizontalPC);
    const isAuthenticated = auth.isAuthenticated;

    const menuItems = useMemo(() => [
        { matchName: 'home',        label: 'Home',        requiresAuth: false },
        { matchName: 'search',      label: 'Search',      requiresAuth: false },
        { matchName: 'leaderboards', label: 'Leaderboards', requiresAuth: false },
        { matchName: 'events',      label: 'My Events',   requiresAuth: true  },
        { matchName: 'trips',       label: 'My Trips',    requiresAuth: true  },
        { matchName: 'teams',       label: 'My Teams',    requiresAuth: true  },
    ], []);

    const handleNavItemClick = (item: typeof menuItems[0]) => {
        if (item.requiresAuth && !isAuthenticated) return;
        setViewEvent(null);
        setDrawerOpen(false);
        navigate('/', { state: { tab: item.matchName } });
    };

    const EventPageSideNavContent = () => (
        <Stack direction={'column'} spacing={2} flex={1} padding={'20px 0px'}
            sx={{ borderRight: 'none', paddingRight: '1px' }}>
            {menuItems.map((item) => (
                <MenuSpanHeader
                    key={item.matchName}
                    matchName={item.matchName}
                    label={item.label}
                    accountTabValue=""
                    setViewEvent={setViewEvent}
                    setAccountTabValue={() => {}}
                    onClick={() => handleNavItemClick(item)}
                    locked={item.requiresAuth && !isAuthenticated}
                    lockTooltip="Sign In to Access"
                />
            ))}
        </Stack>
    );

    console.log('viewEvent',viewEvent);
    console.log('registrationForm',registrationForm);


    useEffect(() => {
        if (viewEvent) {
            const regNotYetOpen = viewEvent.regOpenDate && new Date() < new Date(viewEvent.regOpenDate);
            setRegistrationNotYetOpen(!!regNotYetOpen);
            const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const now = new Date();
            setRegistrationClosed(regNotYetOpen ||
                registrationCloseExclusive(viewEvent?.regCloseDate, tz) <= now ||
                new Date(viewEvent.startDate) < now);

            setFieldFull(viewEvent.playerCap === viewEvent.registrationCount);
            setLeaderboardLocked(!!(viewEvent.startDate && new Date() < new Date(viewEvent.startDate)));
            validateRegistrationForm();
        }
    }, [viewEvent]);

    useEffect(() => {
        if (viewEvent && location.state?.registrationTab === 1) {
            setEventPageTab(1);
            navigate(location.pathname, { replace: true, state: {} });
        }
    }, [viewEvent, location.state?.registrationTab, location.pathname, navigate]);

    useEffect(() => {
        validateRegistrationForm();
    }, [registrationForm, registrationLevelData]);

    //console.log('registrationForm',viewEvent?.registrationForm);

    // Authentication is now handled by route-level wrappers
    // This component can focus on its core functionality
    
    // Get unique related players when authenticated
    useEffect(() => {
        if (auth.isAuthenticated && auth.user?.profile?.sub) {
            getUniqueRelatedPlayers();
        }
    }, [auth.isAuthenticated, auth.user?.profile?.sub]);

    const getUniqueRelatedPlayers = async () => {
        const uniquePlayers = await api.get('/mc/UniqueRelatedPlayers', {
            params: { userID: auth?.user?.profile?.sub }
        });
        console.log('uniquePlayers', uniquePlayers.data);
        setUniqueRelatedPlayers(uniquePlayers.data);
    }

    const validateRegistrationForm = () => {

        const updatedFields = [...registrationFields];

        // Update the required field in updatedFields array directly
        updatedFields.forEach(field => {
            if (field.name === 'teamName') {
                field.required = registrationType !== 'individual';
            }
        });

        // Reg-level required fields: check registrationLevelData
        const regLevelRequiredNulls = updatedFields
            .filter(field => field.required && field.regLevelData)
            .filter(field => {
                const value = registrationLevelData[field.name];
                return value === null || value === undefined || value === '' ||
                    (field.field === 'checkbox' && value === false);
            })
            .length;

        // Per-player required fields: check each formEntry (only non-reg-level fields)
        const perPlayerRequiredNulls = registrationForm.reduce((count, formEntry) => {
            return count + updatedFields
                .filter(field => field.required && !field.regLevelData)
                .filter(field => {
                    const value = formEntry[field.name];
                    return value === null || value === undefined || value === '' ||
                        (Array.isArray(value) && value.length === 0) ||
                        (field.field === 'checkbox' && value === false);
                })
                .length;
        }, 0);

        const requiredNulls = regLevelRequiredNulls + perPlayerRequiredNulls;
        setRegValidated(requiredNulls === 0 ? true : false);
    };

    useEffect(() => {
        const updatedFields = registrationFields.map(field => {
            if (field.name === 'teamName') {
                return {
                    ...field,
                    required: registrationType !== 'individual'
                };
            }
            return field;
        });
        setRegistrationFields(updatedFields);
        validateRegistrationForm();
    }, [registrationType]);

    useEffect(() => {
        if (viewEvent?.useRivalry && rivalryTeam) {
            setRegistrationLevelData((prev) => ({ ...prev, rivalryTeam }));
        }
    }, [rivalryTeam]);

    const resetRegistrationForm = () => {
        if (viewEvent?.registrationForm) {
            const playerFields = viewEvent.registrationForm.filter((field: any) => !field.regLevelData);
            const emptyForm = Array(viewEvent.regQty).fill(null).map(() =>
                playerFields.reduce((acc: any, field: any) => {
                    switch (field.field) {
                        case 'checkbox':
                            acc[field.name] = false;
                            break;
                        case 'select':
                            acc[field.name] = null;
                            break;
                        case 'text':
                        default:
                            acc[field.name] = '';
                            break;
                    }
                    return acc;
                }, {})
            );
            setRegistrationForm(emptyForm);
            setRegistrationLevelData({});
        } else {
            setRegistrationForm([]);
            setRegistrationLevelData({});
        }
    };

    useEffect(() => {
        if (cartItems.length > 0 && viewEvent) {
            const cartItem = cartItems.find((item: any) => item.eventDetails.eventID === viewEvent._id);
            if (cartItem) {
                setRegistrationForm(cartItem.registrationForm);
                setRegistrationFields(viewEvent.registrationForm || []);
                const regLevelKeys = (viewEvent.registrationForm || []).filter((f: any) => f.regLevelData).map((f: any) => f.name);
                const levelData = regLevelKeys.reduce((acc: Record<string, any>, key: string) => {
                    acc[key] = cartItem.registrationForm[0]?.[key] ?? '';
                    return acc;
                }, {});
                setRegistrationLevelData(levelData);
            } else {
                resetRegistrationForm();
                setRegistrationFields(viewEvent.registrationForm || []);
            }
        } else if (viewEvent) {
            resetRegistrationForm();
            setRegistrationFields(viewEvent.registrationForm || []);
        }
    }, [cartItems, viewEvent]);
    

    const getCartItems = async () => {

//console.log('cartItems',cartItems);
//console.log('auth',auth?.user?.profile?.sub);
        const cartCookie = getCookie(`${auth?.user?.profile?.sub}-cartItems`);
        if (cartCookie) {
            setCartItems(JSON.parse(cartCookie));
        } else {
            setCartItems([]);
        }
    }

    function formatDate(event: any) {
        const opts = { weekday: 'short' as const, year: '2-digit' as const, month: 'numeric' as const, day: 'numeric' as const };
        if (new Date(event.startDate).toLocaleDateString('en-US', { timeZone: 'UTC' }) === new Date(event.endDate).toLocaleDateString('en-US', { timeZone: 'UTC' })) {
            return formatDateForDisplay(event.startDate, opts);
        }
        return formatDateForDisplay(event.startDate, opts) + ' - ' + formatDateForDisplay(event.endDate, opts);
    }

    function formatTime(startingTime: string) {
        if (startingTime) {
            return new Date(`2000-01-01T${startingTime}`).toLocaleTimeString('en-US', {hour: 'numeric', minute: '2-digit'});
        }
        else {
            return '';
        }
    }

    useEffect(() => {
        if (cartItems.length === 0) {
            getCartItems();
        }

        if (!viewEvent) {

            const pathSegments = window.location.pathname.split('/');
            const urlEventId = pathSegments[pathSegments.indexOf('events') + 1];

//console.log(urlEventId);

            const getEventData = async () => {
                const matchedEvent = await api.get('/mc/GetEventById', 
                   { params: { _id: urlEventId } });

//console.log('returned event',matchedEvent.data);
                
                setViewEvent(matchedEvent.data);
            }
            getEventData();
        }
    }, []);

    useEffect(() => {
        if (viewEvent) {
            setIsLoading(false);
        }
    }, [viewEvent]);

    useEffect(() => {
        if (auth?.user?.profile?.sub) {
            getCartItems();

            const getUserRegistrations = async () => {
                const matchedRegistration = await api.get('/mc/UserRegistrations', 
                    { params: { userID: auth?.user?.profile?.sub } });
//console.log('returned registrations',matchedRegistration.data);
                setUserRegistrations(matchedRegistration.data);
            }
            getUserRegistrations();
        }
    }, [auth?.user?.profile?.sub]);

    useEffect(() => {
        // Get event ID from URL
        const pathSegments = window.location.pathname.split('/');
        const urlEventId = pathSegments[pathSegments.indexOf('events') + 1];
        setEventId(urlEventId);
//console.log(urlEventId);
//console.log(eventData);
//console.log(eventData.find((event: any) => event._id.toString() === urlEventId));

        // If no event is loaded, fetch it
        if (!viewEvent && urlEventId) {
            const getEventData = async () => {
                try {
//console.log(eventData);
//console.log(urlEventId);
                    const matchedEvent = eventData.find((event: any) => event._id.toString() === urlEventId);
                    setViewEvent(matchedEvent);
                } catch (error) {
                    console.error('Error fetching event:', error);
                    navigate('/'); // Redirect to home if event not found
                }

            };
            getEventData();
        }
    }, [eventData]);

    const isValidEmail = (email: string): boolean => {
        return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email.toLowerCase());
      };

    const formatPhoneNumber = (phone: string): string => {
        // Remove all non-numeric characters
        const cleaned = phone.replace(/\D/g, '');
        
        if (cleaned.length === 0) return '';
        if (cleaned.length <= 3) return cleaned;
        if (cleaned.length <= 6) return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
        return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
    };

    const resolvedRegistrationPrice = useMemo(() => {
        if (!viewEvent?.flightPricing) return null;
        const player = { ...(registrationForm[0] ?? {}), ...registrationLevelData };
        if (!shouldShowResolvedRegistrationPrice(viewEvent, player)) return null;
        const basePrice = getPriceForRegistration(viewEvent, player);
        const totalPrice = getRegistrationTotalPrice(viewEvent, player);
        const discount = getEarlyRegDiscountAmount(viewEvent);
        return { basePrice, totalPrice, discount };
    }, [viewEvent, registrationForm, registrationLevelData]);

    const addToCart = async () => {
        const emailErrors = [];
        const cartStatus = cartItems.find((item: any) => item.eventDetails.eventID === viewEvent._id) ? true : false;

        for (const player of registrationForm) {
            const regCount = await api.get('/mc/CheckDuplicateRegistrations', {
                params: {
                    eventID: viewEvent._id,
                    playerEmail: player.playerEmail
                }
            });

//console.log('Player regCount',player.playerEmail,regCount.data);

            if (regCount.data > 0) {
                emailErrors.push(player.playerEmail);
            }
        }

        if (emailErrors.length > 0) {
            alert(`The following emails are already registered for this event:
                \n${emailErrors.join('\n')}
                \n${cartStatus ? 'Your cart was not updated.' : 'Your registration was not added to your cart.'}
            `);
            return;
        }

        const registrationFormWithLevelData = registrationForm.map((player) => ({
            ...player,
            ...registrationLevelData,
        }));

        // Price is per registration (one line total), not per player
        const firstPlayer = registrationFormWithLevelData[0] ?? {};
        const totalPrice = viewEvent.flightPricing
            ? getRegistrationTotalPrice(viewEvent, firstPlayer)
            : applyEarlyRegDiscount(viewEvent.eventFee, viewEvent);

        const updatedCartItems = [...cartItems.filter((item: any) => item.eventDetails.eventID !== viewEvent._id), 
            {
                eventDetails: {
                    eventID: viewEvent._id,
                    eventName: viewEvent.eventName,
                    price: totalPrice,
                    quantity: 1,
                    eventGroupIDs: viewEvent.eventGroupIDs ?? [],
                },
                registrationForm: registrationFormWithLevelData,
                regType: registrationType,
                rivalryTeam: viewEvent.useRivalry ? rivalryTeam : undefined,
            }
        ];

        setCartItems(updatedCartItems);
        createCookie(`${auth?.user?.profile?.sub}-cartItems`, JSON.stringify(updatedCartItems), 30);
        
    }

    return (
        <Box sx={{ 
            width: '100%', 
            height: '100%',
            overflow: 'hidden',
            position: 'relative'
        }}>
        <PullToRefresh 
            threshold={80} 
            resistance={2}  
            containerRef={stackRef as React.RefObject<HTMLDivElement>} 
            onRefresh={() => {
                navigate(0);
                return Promise.resolve();
            }}>

            <MCHeader label='Moment Central' showCart={true} showMarquee={true} hamburgerFabVisible={isMobileLayout} />

            {isMobileLayout && (
                <Fab
                    onClick={() => setDrawerOpen(true)}
                    sx={{
                        position: 'absolute',
                        top: 10 * factor,
                        left: 10 * factor,
                        zIndex: 1200,
                        width: 'max-content',
                        height: 'max-content',
                        backgroundColor: 'transparent',
                        border: 'none',
                        boxShadow: 'none',
                    }}
                >
                    <MenuIcon id="drawer-menu-icon"
                        sx={{ fontSize: 24 * factor, borderRadius: '50%', padding: '8px', backgroundColor: 'primary.light', color: 'white', boxShadow: 'none' }} />
                </Fab>
            )}

            {isMobileLayout && (
                <Drawer anchor="left" variant="temporary" open={drawerOpen} onClose={() => setDrawerOpen(false)}
                    sx={{ '& .MuiDrawer-paper': { width: 200, boxSizing: 'border-box' } }}
                >
                    <Stack direction={'column'} spacing={2} flex={1}>
                        <Stack direction={'column'} spacing={2} width={190} padding={'20px 0px'}
                            sx={{ paddingRight: '1px' }}>
                            <EventPageSideNavContent />
                        </Stack>
                    </Stack>
                </Drawer>
            )}

            <Stack direction="row" spacing={2} flex={1} sx={isMobileLayout ? { width: '100%', minWidth: 0 } : undefined}>
                {!isMobileLayout && (
                    <Stack direction="column" spacing={2} width={200}
                        height={`calc(100dvh - ${60 * factor}px - env(safe-area-inset-bottom))`}
                        sx={{ borderRight: `1px solid ${appTheme.palette.primary.light}`, paddingRight: '1px' }}>
                        <EventPageSideNavContent />
                    </Stack>
                )}
    
            {viewEvent && !isLoading &&  
                
                    <Stack 
                        direction={'column'} 
                        spacing={2*factor} 
                        flex={1}
                        ref={stackRef}
                        sx={{ 
                            minWidth: 0,
                            backgroundColor: 'white', 
                            borderRadius: 2, 
                            padding: `${10*factor}px ${20*factor}px`, 
                            justifyContent: 'flex-start',
                            overflowY: 'auto',
                            overflowX: 'hidden',
                            minHeight: `calc(100dvh - ${windowSize.appBarHeight + 30*factor}px - env(safe-area-inset-bottom))`,
                            maxHeight: `calc(100dvh - ${windowSize.appBarHeight + 30*factor}px - env(safe-area-inset-bottom))`,
                            WebkitOverflowScrolling: 'touch',
                            '&::-webkit-scrollbar': {
                                display: 'none'
                            }
                        }}>
                        <Stack 
                            id='event-page-name-stack'
                            direction="row" 
                            spacing={2} 
                            alignItems="flex-start"
                            flexWrap="wrap"
                        >
                            {isMobileLayout ? (
                                <IconButton
                                    onClick={() => {
                                        navigate('/', { state: { tab: 'search' } });
                                        setViewEvent(null);
                                    }}
                                    sx={{ color: appTheme.palette.primary.main, p: 0.5, flexShrink: 0 }}
                                    aria-label="Back to Event List"
                                >
                                    <ArrowBack />
                                </IconButton>
                            ) : (
                                <StyledIconButton
                                    icon={<ArrowBack />}
                                    onClick={() => {
                                        navigate('/', { state: { tab: 'search' } });
                                        setViewEvent(null);
                                    }}
                                    appTheme={appTheme}
                                    label="Back to Event List"
                                    factor={1}
                                    color="primary"
                                    width={200}
                                    height={'max-content'}
                                />
                            )}
                            <Stack direction="row" spacing={2.5} alignItems="flex-start" flexShrink={0} flex={1} minWidth={0}>
                                <Box sx={{ 
                                    width: windowSize.isMobile ? 64 : 80, 
                                    height: windowSize.isMobile ? 64 : 80, 
                                    overflow: 'hidden', 
                                    borderRadius: 1,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}>
                                    <img 
                                        src={viewEvent.eventCardImageURL ? (imageCache[viewEvent.eventCardImageURL] || viewEvent.eventCardImageURL) : QUILTED_FLAG_LOGO}
                                        alt={viewEvent.eventName}
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'scale-down',
                                        }}
                                    />
                                </Box>
                                <Stack 
                                    id='event-page-eventName-stack'
                                    direction="column" 
                                    spacing={0.5} 
                                    flex={1} 
                                    minWidth={0}
                                    alignItems="flex-start"
                                >
                                    <Typography
                                        variant={isMobileLayout ? 'h6' : 'h5'}
                                        sx={{
                                            fontWeight: 500,
                                            color: appTheme.palette.primary.main,
                                            textAlign: 'left',
                                            wordBreak: 'break-word',
                                            overflowWrap: 'break-word',
                                        }}>
                                        {viewEvent.eventName}
                                    </Typography>
                                    <Typography
                                        variant={isMobileLayout ? 'subtitle1' : 'h6'}
                                        sx={{
                                            fontWeight: 500,
                                            color: appTheme.palette.primary.main,
                                            textAlign: 'left',
                                            wordBreak: 'break-word',
                                            overflowWrap: 'break-word',
                                            fontSize: isMobileLayout ? '0.875rem' : undefined,
                                        }}>
                                        {formatDate(viewEvent)}{viewEvent.startingTime ? ` | ${formatTime(viewEvent.startingTime)}` : ''}
                                    </Typography>
                                </Stack>
                            </Stack>
                        </Stack>
                        {/* Registration Banner */}
                        {(registrationNotYetOpen || registrationClosed || fieldFull) && (
                            <Box sx={{ width: '100%' }}>
                                {registrationNotYetOpen ? (
                                    <Box sx={{
                                        width: '100%',
                                        backgroundColor: appTheme.palette.secondary.main,
                                        color: appTheme.palette.secondary.contrastText ?? 'white',
                                        padding: 0.5,
                                        borderRadius: 1,
                                    }}>
                                        <Typography variant='caption' sx={{ fontWeight: 500, fontSize: windowSize.isMobile ? '0.7rem' : undefined }}>
                                            Registration Opens {formatDateForDisplay(viewEvent.regOpenDate, { year: 'numeric', month: 'long', day: 'numeric' })}
                                        </Typography>
                                    </Box>
                                ) : registrationClosed ? (
                                    <Box sx={{ width: '100%', backgroundColor: 'rgba(149, 146, 146, 0.4)', padding: 0.5, borderRadius: 1 }}>
                                        <Typography variant='caption' sx={{ fontWeight: 500, fontSize: windowSize.isMobile ? '0.7rem' : undefined }}>
                                            Registration Closed
                                        </Typography>
                                    </Box>
                                ) : fieldFull ? (
                                    <Box sx={{ width: '100%', backgroundColor: 'rgba(149, 146, 146, 0.4)', padding: 0.5, borderRadius: 1 }}>
                                        <Typography variant='caption' sx={{ fontWeight: 500, fontSize: windowSize.isMobile ? '0.7rem' : undefined }}>
                                            Field is Full
                                        </Typography>
                                    </Box>
                                ) : null}
                            </Box>
                        )}
                        <Tabs
                            value={eventPageTab}
                            onChange={(_, v) => {
                                if (v === 1 && (registrationClosed || registrationNotYetOpen)) return;
                                if (v === 2 && leaderboardLocked) return;
                                setEventPageTab(v);
                            }}
                            variant="scrollable"
                            scrollButtons={false}
                            TabIndicatorProps={{ sx: { display: 'none' } }}
                            sx={{
                                flexShrink: 0,
                                minHeight: 0,
                                '& .MuiTabs-flexContainer': {
                                    gap: 1,
                                    flexWrap: 'wrap',
                                    width: '100%',
                                },
                                '& .MuiTabs-scroller': { overflow: 'auto !important' },
                                '& .MuiTab-root': {
                                    minHeight: 32,
                                    flex: isMobileLayout ? 1 : '0 0 auto',
                                    width: isMobileLayout ? undefined : 'max-content',
                                    minWidth: isMobileLayout ? 0 : undefined,
                                    py: 0.5,
                                    px: isMobileLayout ? 1 : 2,
                                    borderRadius: '16px',
                                    textTransform: 'none',
                                    fontWeight: 500,
                                    fontSize: isMobileLayout ? '0.75rem' : '0.875rem',
                                    justifyContent: isMobileLayout ? 'center' : undefined,
                                    '& .MuiSvgIcon-root': {
                                        color: 'primary.dark',
                                    },
                                    '&.Mui-selected': {
                                        backgroundColor: 'primary.extraLight',
                                        color: 'primary.dark',
                                        '& .MuiSvgIcon-root': {
                                            color: 'primary.dark',
                                        },
                                    },
                                },
                            }}
                        >
                            <Tab
                                icon={isMobileLayout ? <InfoOutlined sx={{ fontSize: 20 }} /> : undefined}
                                iconPosition="start"
                                label={isMobileLayout ? '' : 'Info'}
                            />
                            <Tab
                                icon={
                                    isMobileLayout ? (
                                        <Stack direction="row" spacing={0.25} alignItems="center" justifyContent="center">
                                            {userRegistrations.some((r: any) => r.eventID === viewEvent._id) ? (
                                                <TaskAlt sx={{ fontSize: 20, color: 'success.main !important' }} />
                                            ) : (
                                                <>
                                                    <HowToReg sx={{ fontSize: 20 }} />
                                                    {(registrationClosed || registrationNotYetOpen) && <Lock sx={{ fontSize: 14 }} />}
                                                </>
                                            )}
                                        </Stack>
                                    ) : (registrationClosed || registrationNotYetOpen || userRegistrations.some((r: any) => r.eventID === viewEvent._id)) ? (
                                        <Stack direction="row" spacing={0.5} alignItems="center" sx={{ '& .MuiSvgIcon-root': { fontSize: 16 } }}>
                                            {(registrationClosed || registrationNotYetOpen) && <Lock />}
                                            {userRegistrations.some((r: any) => r.eventID === viewEvent._id) && <TaskAlt sx={{ color: 'success.main !important' }} />}
                                        </Stack>
                                    ) : undefined
                                }
                                iconPosition="end"
                                label={isMobileLayout ? 'Register' : 'Registration'}
                                disabled={registrationClosed || registrationNotYetOpen}
                            />
                            {process.env.REACT_APP_LEADERBOARD_URL && (
                                <Tab
                                    icon={
                                        isMobileLayout ? (
                                            <Stack direction="row" spacing={0.25} alignItems="center" justifyContent="center">
                                                <Leaderboard sx={{ fontSize: 20 }} />
                                                {leaderboardLocked && <Lock sx={{ fontSize: 14 }} />}
                                            </Stack>
                                        ) : leaderboardLocked ? (
                                            <Stack direction="row" spacing={0.5} alignItems="center" sx={{ '& .MuiSvgIcon-root': { fontSize: 16 } }}>
                                                <Lock />
                                            </Stack>
                                        ) : undefined
                                    }
                                    iconPosition="end"
                                    label={isMobileLayout ? '' : 'Leaderboard'}
                                    disabled={leaderboardLocked}
                                />
                            )}
                        </Tabs>
                        <Box sx={{ flex: 1, minHeight: 0, minWidth: 0, overflowY: 'auto', overflowX: 'hidden', display: 'flex', flexDirection: 'column', width: '100%' }}>
                            {eventPageTab === 0 && (
                                <Stack
                                    id='event-page-details-stack-section1'
                                    direction={'column'}
                                    spacing={2}
                                    sx={{ pt: 1, alignItems: 'stretch', width: '100%' }}
                                >
                                    <Box
                                        id='event-page-details-stack-subsection1'
                                        sx={{
                                            display: 'grid',
                                            gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
                                            gap: 2 * factor,
                                            width: '100%',
                                            minWidth: 0,
                                            alignItems: 'stretch',
                                        }}
                                    >
                                        <Box sx={{
                                            p: 2,
                                            borderRadius: 2,
                                            backgroundColor: 'grey.50',
                                            border: '1px solid',
                                            borderColor: 'divider',
                                            display: 'flex',
                                            flexDirection: 'column',
                                        }}>
                                            <Typography variant='subtitle1' sx={{ fontWeight: 600, mb: 1.5, color: 'text.primary' }}>Course Information</Typography>
                                            <Typography variant="body2" sx={{ color: 'text.secondary', wordBreak: 'break-word' }}>{viewEvent.courseName}</Typography>
                                            <Typography variant="body2" sx={{ color: 'text.secondary', wordBreak: 'break-word', mt: 0.5 }}>
                                                {viewEvent.courseInfo?.location ? [
                                                    viewEvent.courseInfo.location.address,
                                                    viewEvent.courseInfo.location.city,
                                                    `${viewEvent.courseInfo.location.state || ''} ${viewEvent.courseInfo.location.zip || ''}`.trim(),
                                                ].filter(Boolean).join(', ') : ''}
                                            </Typography>
                                        </Box>
                                        <Box sx={{
                                            p: 2,
                                            borderRadius: 2,
                                            backgroundColor: 'grey.50',
                                            border: '1px solid',
                                            borderColor: 'divider',
                                            display: 'flex',
                                            flexDirection: 'column',
                                        }}>
                                            <Typography variant='subtitle1' sx={{ fontWeight: 600, mb: 1.5, color: 'text.primary' }}>Event Information</Typography>
                                            <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1 }}>
                                                {viewEvent.playFormat} — {viewEvent.playType}
                                                {viewEvent.eventRegion && viewEvent.eventState && ` · ${viewEvent.eventRegion}, ${viewEvent.eventState}`}
                                            </Typography>
                                            <Box sx={{ display: 'grid', gridTemplateColumns: '1.25fr 1.25fr 0.9fr', gap: '8px 24px', width: '100%' }}>
                                                <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.5, minWidth: 0 }}>
                                                    <Typography variant="body2" sx={{ fontWeight: 600, color: 'text.primary', flexShrink: 0 }}>Holes:</Typography>
                                                    <Typography variant="body2" color="text.secondary">{viewEvent.totalHoles}</Typography>
                                                </Box>
                                                <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.5, minWidth: 0 }}>
                                                    <Typography variant="body2" sx={{ fontWeight: 600, color: 'text.primary', flexShrink: 0 }}>Rounds:</Typography>
                                                    <Typography variant="body2" color="text.secondary">{viewEvent.totalRounds}</Typography>
                                                </Box>
                                                <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.5, minWidth: 0 }}>
                                                    <Typography variant="body2" sx={{ fontWeight: 600, color: 'text.primary', flexShrink: 0 }}>Field:</Typography>
                                                    <Typography variant="body2" color="text.secondary">{viewEvent.playerCap}</Typography>
                                                </Box>
                                                <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.5, minWidth: 0 }}>
                                                    <Typography variant="body2" sx={{ fontWeight: 600, color: 'text.primary', flexShrink: 0 }}>Sign Up:</Typography>
                                                    <Typography variant="body2" color="text.secondary">{viewEvent.regType}</Typography>
                                                </Box>
                                                <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.5, minWidth: 0 }}>
                                                    <Typography variant="body2" sx={{ fontWeight: 600, color: 'text.primary', flexShrink: 0 }}>Closes:</Typography>
                                                    <Typography variant="body2" color="text.secondary">{formatDateForDisplay(viewEvent.regCloseDate)}</Typography>
                                                </Box>
                                                <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.5, minWidth: 0 }}>
                                                    <Typography variant="body2" sx={{ fontWeight: 600, color: 'text.primary', flexShrink: 0 }}>Open:</Typography>
                                                    <Typography variant="body2" color="text.secondary">{viewEvent.playerCap - viewEvent.registrationCount}</Typography>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Box>
                                    <Divider
                                        orientation={windowSize.verticalMobile || windowSize.verticalPC !== 'none' || ['small', 'medium'].includes(windowSize.horizontalPC) ? 'horizontal' : 'vertical'}
                                        flexItem
                                        sx={{ my: 0 }}
                                    />
                                    <Box
                                        sx={{
                                            minWidth: 0,
                                            pt: 0.5,
                                            ...(viewEvent.registrationInfo?.trim()
                                                ? {
                                                      minHeight: `calc(100dvh - ${windowSize.appBarHeight + 250}px - env(safe-area-inset-bottom))`,
                                                  }
                                                : { minHeight: 200 }),
                                        }}
                                    >
                                        <TipTapEditor
                                            value={viewEvent.registrationInfo}
                                            readOnly={true}
                                            onChange={() => {}}
                                            embedInScroll={!!viewEvent.registrationInfo?.trim()}
                                        />
                                    </Box>
                                </Stack>
                            )}
                            {eventPageTab === 1 && (
                                <Stack 
                                    id='event-page-registration-form-stack'
                                    direction="column"
                                    sx={{
                                        pt: 0.5,
                                        flex: 1,
                                        minHeight: 0,
                                        minWidth: 0,
                                        alignItems: 'stretch',
                                        width: '100%',
                                        maxWidth: 1200,
                                        mx: 'auto',
                                        overflow: 'hidden',
                                    }}
                                >
                                    {/* Fixed header - outside scroll */}
                                    <Stack direction="column" spacing={1.5 * factor} flexShrink={0} sx={{ width: '100%', minWidth: 0 }}>
                                        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', py: 0.5 * factor }}>
                                            <PriceDisplayModeToggle />
                                        </Box>
                                        {!registrationClosed && !fieldFull && (
                                            <Stack
                                                id={`tb-overview-event-${viewEvent._id}-fee-stack`}
                                                direction="row"
                                                alignItems="center"
                                                justifyContent="center"
                                                flexWrap="wrap"
                                                gap={isMobileLayout ? 1 : 2}
                                                sx={{ width: '100%', minWidth: 0 }}
                                            >
                                            <Stack
                                                direction={isMobileLayout ? 'column' : 'row'}
                                                alignItems={isMobileLayout ? 'flex-start' : 'center'}
                                                flexWrap="wrap"
                                                gap={0.5}
                                                sx={{ flex: '1 1 auto', minWidth: 0, justifyContent: 'center', rowGap: 0 }}
                                            >
                                                {(viewEvent.eventFee || viewEvent.flightPricing) && (
                                                    viewEvent.flightPricing ? (() => {
                                                        const range = getFlightPriceRange(viewEvent);
                                                        if (!range) return <Typography variant="subtitle1">Price by division/flight</Typography>;
                                                        const regQty = viewEvent.regQty ?? 1;
                                                        const earlyRegActive = isEarlyRegistrationActive(viewEvent) && getEarlyRegDiscountAmount(viewEvent) > 0;
                                                        const discount = getEarlyRegDiscountAmount(viewEvent);
                                                        const minWithDiscount = range.min - discount;
                                                        const maxWithDiscount = range.max - discount;
                                                        const scaledRange = scalePriceRangeForDisplay(range, regQty, priceDisplayMode);
                                                        const scaledMinWithDiscount = scalePriceForDisplay(minWithDiscount, regQty, priceDisplayMode);
                                                        const scaledMaxWithDiscount = scalePriceForDisplay(maxWithDiscount, regQty, priceDisplayMode);
                                                        const regularRangeLabel = scaledRange.min === scaledRange.max
                                                            ? formatDisplayPrice(scaledRange.min)
                                                            : `${formatDisplayPrice(scaledRange.min)} – ${formatDisplayPrice(scaledRange.max)}`;
                                                        const currentRangeLabel = earlyRegActive
                                                            ? (scaledMinWithDiscount === scaledMaxWithDiscount
                                                                ? formatDisplayPrice(scaledMinWithDiscount)
                                                                : `${formatDisplayPrice(scaledMinWithDiscount)} – ${formatDisplayPrice(scaledMaxWithDiscount)}`)
                                                            : (scaledRange.min === scaledRange.max
                                                                ? formatDisplayPrice(scaledRange.min)
                                                                : `From ${formatDisplayPrice(scaledRange.min)} – ${formatDisplayPrice(scaledRange.max)}`);
                                                        const priceSuffix = (
                                                            <>
                                                                <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>{getPriceDisplaySuffix(priceDisplayMode)}</Typography>
                                                                {!isMobileLayout && <Typography variant="subtitle1" sx={{ fontWeight: 500, color: 'text.secondary' }}>·</Typography>}
                                                            </>
                                                        );
                                                        const priceDisplay = (
                                                            <EarlyRegPriceDisplay
                                                                currentPriceLabel={currentRangeLabel}
                                                                regularPriceLabel={regularRangeLabel}
                                                                cutoffDate={viewEvent.earlyRegCutoffDate}
                                                                earlyRegActive={earlyRegActive}
                                                                suffix={priceSuffix}
                                                            />
                                                        );
                                                        return isMobileLayout
                                                            ? <Stack direction="row" alignItems="center" flexWrap="wrap" gap={0.5}>{priceDisplay}</Stack>
                                                            : priceDisplay;
                                                    })() : (() => {
                                                        const regQty = viewEvent.regQty ?? 1;
                                                        const earlyRegActive = isEarlyRegistrationActive(viewEvent) && getEarlyRegDiscountAmount(viewEvent) > 0;
                                                        const regularPriceLabel = formatDisplayPrice(
                                                            scalePriceForDisplay(viewEvent.eventFee, regQty, priceDisplayMode)
                                                        );
                                                        const currentPriceLabel = earlyRegActive
                                                            ? formatDisplayPrice(
                                                                scalePriceForDisplay(
                                                                    applyEarlyRegDiscount(viewEvent.eventFee, viewEvent),
                                                                    regQty,
                                                                    priceDisplayMode
                                                                )
                                                            )
                                                            : regularPriceLabel;
                                                        const priceSuffix = (
                                                            <>
                                                                <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>{getPriceDisplaySuffix(priceDisplayMode)}</Typography>
                                                                {!isMobileLayout && <Typography variant="subtitle1" sx={{ fontWeight: 500, color: 'text.secondary' }}>·</Typography>}
                                                            </>
                                                        );
                                                        const priceDisplay = (
                                                            <EarlyRegPriceDisplay
                                                                currentPriceLabel={currentPriceLabel}
                                                                regularPriceLabel={regularPriceLabel}
                                                                cutoffDate={viewEvent.earlyRegCutoffDate}
                                                                earlyRegActive={earlyRegActive}
                                                                suffix={priceSuffix}
                                                            />
                                                        );
                                                        return isMobileLayout
                                                            ? <Stack direction="row" alignItems="center" flexWrap="wrap" gap={0.5}>{priceDisplay}</Stack>
                                                            : priceDisplay;
                                                    })()
                                                )}
                                                <Typography variant='subtitle1' sx={{ fontWeight: 500 }}>Closes: {formatDateForDisplay(viewEvent.regCloseDate)}</Typography>
                                            </Stack>
                                            {auth?.user && (
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    disabled={!regValidated}
                                                    onClick={() => addToCart()}
                                                    sx={{ flexShrink: 0 }}
                                                >
                                                    {cartItems.find((item: any) => item.eventDetails.eventID === viewEvent._id) ? 'Update Cart' : 'Add to Cart'}
                                                </Button>
                                            )}
                                        </Stack>
                                    )}
                                        {auth?.user && !registrationClosed && !fieldFull && (
                                            <Stack direction="column" spacing={1} alignItems="center">
                                                <Stack direction="row" spacing={1} justifyContent="center">
                                                    <FormControl>
                                                        <RadioGroup
                                                            row
                                                            value={registrationType}
                                                            onChange={(e) => setRegistrationType(e.target.value)}
                                                        >
                                                            <FormControlLabel 
                                                                value="individual"
                                                                control={<Radio />}
                                                                label="Individual Pair"
                                                            />
                                                            <FormControlLabel
                                                                value="team"
                                                                control={<Radio />} 
                                                                label="Pair on a Team"
                                                            />
                                                        </RadioGroup>
                                                    </FormControl>
                                                </Stack>
                                                {viewEvent?.useRivalry && viewEvent?.rivalry && (
                                                    <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
                                                        <Typography variant="subtitle2" sx={{ fontWeight: 500 }}>Rivalry Team:</Typography>
                                                        <FormControl size="small" sx={{ minWidth: 160 }}>
                                                            <RadioGroup
                                                                row
                                                                value={rivalryTeam}
                                                                onChange={(e) => setRivalryTeam(e.target.value)}
                                                            >
                                                                <FormControlLabel
                                                                    value={viewEvent.rivalry.teamA?.name ?? ''}
                                                                    control={<Radio />}
                                                                    label={viewEvent.rivalry.teamA?.name ?? 'Team A'}
                                                                />
                                                                <FormControlLabel
                                                                    value={viewEvent.rivalry.teamB?.name ?? ''}
                                                                    control={<Radio />}
                                                                    label={viewEvent.rivalry.teamB?.name ?? 'Team B'}
                                                                />
                                                            </RadioGroup>
                                                        </FormControl>
                                                    </Stack>
                                                )}
                                            </Stack>
                                        )}
                                    </Stack>
                                    {/* Scrollable content */}
                                    <Box sx={{ flex: 1, minHeight: 0, minWidth: 0, overflowY: 'auto', overflowX: 'hidden', width: '100%', pt: 1.5 }}>
                                        <Stack direction="column" spacing={1.5 * factor} alignItems="center" sx={{ width: '100%' }}>
                                            {userRegistrations.some((registration: any) => registration.eventID === viewEvent._id) && (
                                                <Stack direction="row" spacing={1} alignItems="center" justifyContent="center" flexWrap="wrap" sx={{ width: '100%' }}>
                                                    <UserRegistered eventID={viewEvent._id} position="inline" width={24} iconOnly />
                                                    <Stack direction="column" spacing={0.5}>
                                                        <Typography variant="h5">You are registered for this event</Typography>
                                                        <Typography variant="subtitle1">Please contact the event coordinator for any questions about your registration.</Typography>
                                                        <Typography variant="subtitle1">You may add additional pairs for the event below.</Typography>
                                                    </Stack>
                                                </Stack>
                                            )}
                                            {!auth?.user && !registrationClosed && !fieldFull && (
                                                <Stack direction={'column'} spacing={2} alignItems={'center'}>
                                                    <Typography variant="h6">Login or sign up to register for this event</Typography>
                                                    <StyledIconButton
                                                        icon={<Login sx={{ marginRight: 2}}/>}
                                                        appTheme={appTheme}
                                                        label="Login"
                                                        factor={1}
                                                        color="primary"
                                                        width={100}
                                                        height={50}
                                                        onClick={() => {
                                                            localStorage.setItem('redirectURL', `/events/${viewEvent._id}`);
                                                            auth.signinRedirect();
                                                        }}
                                                    />
                                                </Stack>
                                            )}
                                            {auth?.user && !registrationClosed && !fieldFull && (
                                                <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                    {registrationFields?.filter((field: any) => {
                                                if (!field.regLevelData) return false;
                                                if (viewEvent?.flighting?.props?.assignmentMode === 'auto' && (field.name === 'division' || field.name === 'flight')) return false;
                                                return true;
                                            }).length > 0 && (
                                                <Box
                                                    key="reg-level-fields"
                                                    sx={{
                                                        display: 'flex',
                                                        flexDirection: isMobileLayout ? 'column' : 'row',
                                                        flexWrap: isMobileLayout ? undefined : 'wrap',
                                                        gap: 2 * factor,
                                                        width: '100%',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        py: 1.5 * factor,
                                                    }}
                                                >
                                                    {registrationFields
                                            .filter((field: any) => field.regLevelData &&
                                                !(viewEvent?.flighting?.props?.assignmentMode === 'auto' && (field.name === 'division' || field.name === 'flight')))
                                            .map((field: any, fieldIndex: number) => {
                                                const fieldWidth = 280;
                                                switch (field.field) {
                                                    case 'text':
                                                        return (
                                                            <Box key={`reglevel-text-${field.name}-${fieldIndex}`} sx={{ width: isMobileLayout ? '100%' : fieldWidth, minWidth: isMobileLayout ? undefined : fieldWidth, flex: isMobileLayout ? undefined : `0 0 ${fieldWidth}px` }}>
                                                            <Stack direction="row" alignItems="center" spacing={0.5}>
                                                                <Box sx={{ flex: 1, minWidth: 0 }}>
                                                                <StyledTextboxInput
                                                                    label={field.label + (field.required ? ' (* Required)' : '')}
                                                                    type={field.type}
                                                                    value={field.type === 'tel' ? formatPhoneNumber(registrationLevelData[field.name] || '') : registrationLevelData[field.name] || ''}
                                                                    error={field.required && (registrationLevelData[field.name] === '' || registrationLevelData[field.name] == null)}
                                                                    onChange={(e) => {
                                                                        setRegistrationLevelData((prev) => ({
                                                                            ...prev,
                                                                            [field.name]: field.type === 'email' ? e.target.value.toLowerCase() : e.target.value,
                                                                        }));
                                                                    }}
                                                                    onBlur={() => validateRegistrationForm()}
                                                                    appTheme={appTheme}
                                                                    fullWidth
                                                                />
                                                                </Box>
                                                                {field.tooltip && (
                                                                    <FieldInfoButton tooltip={field.tooltip} />
                                                                )}
                                                            </Stack>
                                                            </Box>
                                                        );
                                                    case 'select':
                                                        return (
                                                            <Box key={`reglevel-select-${field.name}-${fieldIndex}`} sx={{ width: isMobileLayout ? '100%' : fieldWidth, minWidth: isMobileLayout ? undefined : fieldWidth, flex: isMobileLayout ? undefined : `0 0 ${fieldWidth}px` }}>
                                                            <Stack direction="row" alignItems="center" spacing={0.5}>
                                                                <Box sx={{ flex: 1, minWidth: 0 }}>
                                                                <StyledAutocompleteInput
                                                                    label={field.label + (field.required ? ' (* Required)' : '')}
                                                                    options={getRegistrationFieldOptions(
                                                                        field,
                                                                        viewEvent,
                                                                        {
                                                                            ...(field.name === 'flight' ? { selectedDivision: registrationLevelData.division ?? null } : {}),
                                                                            priceDisplayMode,
                                                                            regQty: viewEvent.regQty ?? 1,
                                                                        }
                                                                    )}
                                                                    value={registrationLevelData[field.name] || ''}
                                                                    onChange={(e, newValue) => {
                                                                        setRegistrationLevelData((prev) => {
                                                                            const next: Record<string, any> = { ...prev, [field.name]: newValue?.value ?? '' };
                                                                            if (field.name === 'division') next.flight = '';
                                                                            return next;
                                                                        });
                                                                        validateRegistrationForm();
                                                                    }}
                                                                    onBlur={() => validateRegistrationForm()}
                                                                    appTheme={appTheme}
                                                                    fullWidth
                                                                    renderInput={() => <TextField />}
                                                                />
                                                                </Box>
                                                                {field.tooltip && (
                                                                    <FieldInfoButton tooltip={field.tooltip} />
                                                                )}
                                                            </Stack>
                                                            </Box>
                                                        );
                                                    default:
                                                        return null;
                                                }
                                            })}
                                                </Box>
                                            )}

                                            {resolvedRegistrationPrice && (
                                                <Stack
                                                    direction="row"
                                                    spacing={1}
                                                    flexWrap="wrap"
                                                    alignItems="center"
                                                    justifyContent="center"
                                                    sx={{ width: '100%', py: 0.5 }}
                                                >
                                                    <EarlyRegPriceDisplay
                                                        prefix={
                                                            <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                                                                Registration price:
                                                            </Typography>
                                                        }
                                                        currentPriceLabel={formatDisplayPrice(
                                                            scalePriceForDisplay(
                                                                resolvedRegistrationPrice.totalPrice,
                                                                viewEvent.regQty ?? 1,
                                                                priceDisplayMode
                                                            )
                                                        )}
                                                        regularPriceLabel={formatDisplayPrice(
                                                            scalePriceForDisplay(
                                                                resolvedRegistrationPrice.basePrice,
                                                                viewEvent.regQty ?? 1,
                                                                priceDisplayMode
                                                            )
                                                        )}
                                                        cutoffDate={viewEvent.earlyRegCutoffDate}
                                                        earlyRegActive={resolvedRegistrationPrice.discount > 0}
                                                    />
                                                </Stack>
                                            )}

                                            {/* Per-player forms: grid on desktop, column on mobile */}
                                            <Box
                                                sx={{
                                                    display: isMobileLayout ? 'flex' : 'grid',
                                                    flexDirection: isMobileLayout ? 'column' : undefined,
                                                    gridTemplateColumns: isMobileLayout ? undefined : 'repeat(auto-fit, minmax(280px, 1fr))',
                                                    gap: 3 * factor,
                                                    width: '100%',
                                                    maxWidth: '100%',
                                                    justifyContent: 'center',
                                                    alignItems: 'flex-start',
                                                    mx: 'auto',
                                                }}
                                            >
                                                {[...Array(viewEvent.regQty)].map((_, index) => (
                                                    <Stack key={`player-${index}`} direction="column" spacing={3*factor} sx={{ minWidth: 0, width: '100%' }}>

                                        <Typography variant="h6">Player {index + 1}</Typography>

                                        <StyledAutocompleteInput
                                            label="Player Name"
                                            placeholder="Type or Select a Player"
                                            options={uniqueRelatedPlayers}
                                            freeSolo={true}
                                            getOptionLabel={(option: any) => {
                                                if (!option || typeof option === 'string') return option || '';
                                                return option.playerName || '';
                                            }}
                                            renderOption={(props, option: any) => (
                                                <li {...props} key={option.playerEmail || option.playerName || Math.random()}>
                                                    {option.playerName} ({option.playerEmail})
                                                </li>
                                            )}
                                            value={registrationForm[index].playerName || ''}
                                            onChange={(e, newValue) => {
                                                const newForm = [...registrationForm];
                                                if (typeof newValue === 'string') {
                                                    // Free solo text input
                                                    newForm[index] = {
                                                        ...newForm[index],
                                                        playerName: newValue
                                                    };
                                                } else if (newValue && typeof newValue === 'object') {
                                                    // Selection from options - dynamically map all matching keys
                                                    const updatedFields: any = {};
                                                    Object.keys(newForm[index]).forEach(key => {
                                                        if (newValue.hasOwnProperty(key)) {
                                                            updatedFields[key] = newValue[key] || '';
                                                        }
                                                    });
                                                    
                                                    newForm[index] = {
                                                        ...newForm[index],
                                                        ...updatedFields,
                                                        liabilityWaiver: false
                                                    };
                                                } else {
                                                    // No selection (cleared)
                                                    newForm[index] = {
                                                        ...newForm[index],
                                                        playerEmail: '',
                                                        playerName: '',
                                                        liabilityWaiver: false
                                                    };
                                                }
                                                setRegistrationForm(newForm);
                                            }}
                                            onBlur={(e) => {
                                                // Handle when user clicks out of the component
                                                const target = e.target as HTMLInputElement;
                                                const inputValue = target.value;
                                                const currentValue = uniqueRelatedPlayers.find((player: any) => player.playerEmail === registrationForm[index].playerEmail);
                                                
                                                // If input is empty, clear all form keys for this player
                                                if (!inputValue || inputValue.trim() === '') {
                                                    const newForm = [...registrationForm];
                                                    const clearedFields: any = {};
                                                    Object.keys(newForm[index]).forEach(key => {
                                                        if (typeof newForm[index][key] === 'boolean') {
                                                            clearedFields[key] = false;
                                                        } else {
                                                            clearedFields[key] = '';
                                                        }
                                                    });
                                                    
                                                    newForm[index] = {
                                                        ...newForm[index],
                                                        ...clearedFields,
                                                    };
                                                    setRegistrationForm(newForm);
                                                }
                                                // Only save text input if current value is a string (free solo) or null
                                                else if (!currentValue || typeof currentValue === 'string') {
                                                    const newForm = [...registrationForm];
                                                    newForm[index] = {
                                                        ...newForm[index],
                                                        playerName: inputValue.trim()
                                                    };
                                                    setRegistrationForm(newForm);
                                                }
                                            }}
                                            appTheme={appTheme}
                                            fullWidth
                                            renderInput={() => <TextField />}
                                        />

                                        {registrationFields && registrationFields
                                            .filter((field: any) => {
                                                if (field.name === 'playerName') return false;
                                                if (field.regLevelData) return false;
                                                if (viewEvent?.flighting?.props?.assignmentMode === 'auto' && (field.name === 'division' || field.name === 'flight')) return false;
                                                return true;
                                            })
                                            .map((field: any, fieldIndex: number) => {
                                            switch(field.field) {
                                                case 'text':
                                                    return (
                                                        <Stack key={`text-${field.name}-${index}-${fieldIndex}`} direction="row" alignItems="center" spacing={0.5} sx={{ width: '100%' }}>
                                                            <Box sx={{ flex: 1, minWidth: 0 }}>
                                                                <StyledTextboxInput
                                                                    label={field.label + (field.required ? ' (* Required)' : '')}
                                                                    type={field.type}
                                                                    value={field.type === 'tel' ? formatPhoneNumber(registrationForm[index][field.name] || '') : registrationForm[index][field.name] || ''}
                                                                    error={field.required && (field.type === 'email'
                                                                        ? ((!isValidEmail(registrationForm[index][field.name]) && registrationForm[index][field.name] !== '') ||
                                                                            registrationForm[index][field.name] === '')
                                                                        : registrationForm[index][field.name] === '')}
                                                                    helperText={(field.type === 'email' && !isValidEmail(registrationForm[index][field.name]) && registrationForm[index][field.name] !== '') ? 'Please enter a valid email address' : ''}

                                                                    onChange={(e) => {
                                                                        const newForm = [...registrationForm]
                                                                        newForm[index] = {
                                                                            ...newForm[index],
                                                                            [field.name]: field.type === 'email' ? e.target.value.toLowerCase() : 
                                                                            //field.type === 'tel' ? formatPhoneNumber(e.target.value) :
                                                                            e.target.value
                                                                        };
                                                                        setRegistrationForm(newForm);
                                                                    }}
                                                                    onBlur={() => {
                                                                        validateRegistrationForm();
                                                                    }}
                                                                    appTheme={appTheme}
                                                                    fullWidth
                                                                />
                                                            </Box>
                                                            {field.tooltip && (
                                                                <FieldInfoButton tooltip={field.tooltip} />
                                                            )}
                                                        </Stack>
                                                    );
                                                case 'select':
                                                    return (
                                                        <Stack key={`select-${field.name}-${index}-${fieldIndex}`} direction="row" alignItems="center" spacing={0.5} sx={{ width: '100%' }}>
                                                            <Box sx={{ flex: 1, minWidth: 0 }}>
                                                                <StyledAutocompleteInput
                                                                    label={field.label + (field.required ? ' (* Required)' : '')}
                                                                    options={getRegistrationFieldOptions(
                                                                        field,
                                                                        viewEvent,
                                                                        {
                                                                            ...(field.name === 'flight' ? { selectedDivision: registrationForm[index].division ?? null } : {}),
                                                                            priceDisplayMode,
                                                                            regQty: viewEvent.regQty ?? 1,
                                                                        }
                                                                    )}
                                                                    value={registrationForm[index][field.name] || 'Select an option'}
                                                                    onChange={(e, newValue) => {
                                                                        const newForm = [...registrationForm];
                                                                        newForm[index] = {
                                                                            ...newForm[index],
                                                                            [field.name]: newValue.value
                                                                        };
                                                                        if (field.name === 'division') {
                                                                            newForm[index].flight = null;
                                                                        }
                                                                        setRegistrationForm(newForm);
                                                                    }}
                                                                    onBlur={() => {
                                                                        validateRegistrationForm();
                                                                    }}
                                                                    appTheme={appTheme}
                                                                    fullWidth
                                                                    renderInput={() => <TextField />}
                                                                />
                                                            </Box>
                                                            {field.tooltip && (
                                                                <FieldInfoButton tooltip={field.tooltip} />
                                                            )}
                                                        </Stack>
                                                    );
                                                case 'checkbox':
                                                    return (
                                                        <Box 
                                                            key={`checkbox-${field.name}-${index}-${fieldIndex}`} 
                                                            sx={{ display: 'flex', height: 25*factor, alignItems: 'center' }}
                                                            onKeyDown={(e) => {
                                                                if (e.key === 'Enter') {
                                                                    const newForm = [...registrationForm];
                                                                    newForm[index] = {
                                                                        ...newForm[index],
                                                                        [field.name]: !registrationForm[index][field.name]
                                                                    };
                                                                    setRegistrationForm(newForm);
                                                                    
                                                                }
                                                            }}
                                                        >
                                                            <Checkbox 
                                                                checked={!!registrationForm[index][field.name]}
                                                                onChange={(e) => {
                                                                    const newForm = [...registrationForm];
                                                                    newForm[index] = {
                                                                        ...newForm[index],
                                                                        [field.name]: e.target.checked
                                                                    };
                                                                    setRegistrationForm(newForm);   
                                                                }}
                                                                onBlur={() => {
                                                                    validateRegistrationForm();
                                                                }}
                                                                sx={{
                                                                    color: field.required && registrationForm[index][field.name] === false ?
                                                                        'error.main' : appTheme.palette.primary.main,
                                                                    '&.Mui-checked': {
                                                                        color: appTheme.palette.primary.main,
                                                                    },
                                                                }}
                                                            />
                                                            <Typography
                                                                variant="subtitle2"
                                                                sx={{
                                                                    color: field.required && registrationForm[index][field.name] === false ? 'error.main' : 'inherit',
                                                                }}
                                                            >{field.label + (field.required ? ' *' : '')}</Typography>
                                                            {field.tooltip && (
                                                                <FieldInfoButton tooltip={field.tooltip} sx={{ ml: 0.5 }} />
                                                            )}
                                                            {field.fileURL && (
                                                                <Typography 
                                                                    variant="subtitle2"
                                                                    sx={{
                                                                        color: 'primary.main',
                                                                        textDecoration: 'underline',
                                                                        marginLeft: 1,
                                                                        cursor: 'pointer',
                                                                        '&:hover': {
                                                                            opacity: 0.8
                                                                        }
                                                                    }}
                                                                    onClick={() => {
                                                                        const popup = window.open(`${window.location.origin}/document-viewer`, '_blank', 'width=800,height=600,menubar=no,toolbar=no,location=no,status=no');
                                                                        if (popup) {
                                                                            popup.document.write(`
                                                                                <html>
                                                                                    <head>
                                                                                        <title>${viewEvent.eventName} - ${field.label}</title>
                                                                                        <base href="${window.location.origin}">
                                                                                        <style>
                                                                                            body { margin: 0; overflow: hidden; }
                                                                                            iframe { border: none; width: 100%; height: 100vh; }
                                                                                        </style>
                                                                                    </head>
                                                                                    <body>
                                                                                        <iframe src="${field.fileURL}" width="100%" height="100%"></iframe>
                                                                                    </body>
                                                                                </html>
                                                                            `);
                                                                            popup.document.close();
                                                                        }
                                                                    }}
                                                                >
                                                                    view file
                                                                </Typography>
                                                            )}
                                                        </Box>
                                                    );
                                                default:
                                                    return null;
                                            }
                                        })}
                                                    </Stack>
                                                ))}
                                            </Box>
                                                </Box>
                                            )}
                                        </Stack>
                                    </Box>
                                </Stack>
                            )}
                            {eventPageTab === 2 && process.env.REACT_APP_LEADERBOARD_URL && (
                                <Box sx={{
                                    position: 'relative',
                                    width: '100%',
                                    flex: 1,
                                    minHeight: 300,
                                    pt: 0.5,
                                    overflow: 'hidden',
                                }}>
                                    <iframe
                                        key={viewEvent._id}
                                        src={`${process.env.REACT_APP_LEADERBOARD_URL}?headless=true&hideSelector=true&eventID=${viewEvent._id}`}
                                        title="Leaderboard"
                                        style={{
                                            position: 'absolute',
                                            top: 8,
                                            left: 0,
                                            right: 0,
                                            bottom: 0,
                                            width: '100%',
                                            height: 'calc(100% - 8px)',
                                            border: 'none',
                                        }}
                                    />
                                </Box>
                            )}
                        </Box>
                </Stack>
            }
            </Stack>
            </PullToRefresh>
        </Box>
    )
}

